import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { CareerInfoService } from '../../../_services/index';

@Component({
  selector: 'professional-goal-questiontype',
  templateUrl: './professionalgoal.questiontype.component.html',
  providers:[CareerInfoService]
})
export class ProfessionalGoalComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() questioninitmixin:any;
  @Input() disabled:boolean;
  formError:false;
  value:'';
  formSegment:FormGroup;
  professionalGoalsData:Array<any>;

  constructor(
    public api: CareerInfoService
  ){
  }

  isValid():boolean {
    if(this.disabled) {
      return true;
    }
    return !!this.value;
  }
  validate():boolean {
    return true;
  }

  public getValue():object {
    var result={};
    if(!this.disabled) {
      result[this.questionid]=this.formSegment.value['item'];
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  ngOnInit() {
    var init={};
    init['item']=new FormControl(this.value);
    this.formSegment=new FormGroup(init);


    var sub = this.api.professionalGoalsList()
      .subscribe(responseData => {
        sub.unsubscribe();
          if ( responseData.status === 1) {
              this.professionalGoalsData = responseData.data.professionalgoals;
              this.formSegment.patchValue({
                item: this.value || this.professionalGoalsData[0].name
              });
          }
      });
  }

  ngOnDestroy() {
  }
}




// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/professionalgoal.questiontype.component.ts